var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.adminTotpSetup },
    [
      !_vm.shouldShowVerifyAccount
        ? _c("AdminGetAuthApp", { on: { onGoForward: _vm.goForward } })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowVerifyAccount
        ? _c("AdminVerifyAccount", {
            attrs: {
              error: _vm.errorMessage,
              isLoading: _vm.isLoading,
              totp: _vm.totp,
            },
            on: { onGoBack: _vm.goBack, onSubmit: _vm.submit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }